module.exports = __webpack_public_path__ + "img/flamethrower-turret-base-south.c7fa4f21.png";